var Handlebars = require("/Users/niall/projects/workflows-js/node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<p>\nTo connect nodes, select a subject node. A small blue dot will appear beneath it. Drag from this dot to point at the target node. If the target node is highlighted green, you can let go and a connection will be formed. If the target node is highlighted red, you cannot connect these nodes as they are of the same type. Two operations must be separated by a data step, and vice versa with data.\n</p>\n";
},"useData":true});


//////////////////
// WEBPACK FOOTER
// ./src/templates/edit_docs/snippets/connect_nodes.hbs
// module id = 153
// module chunks = 0